import { GET_PAYMENT_LIST_ACTION_TYPE } from "../../../utils/constants";


const initialState = [];

function adminAccountReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_PAYMENT_LIST_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default adminAccountReducer